import {
	PersonSmartSearchParameterModel ,
	IPersonListingModel , PersonSmartSuggestionModel
} from "../../../models/person";
import { ActionTree } from "vuex";
import { GenericBaseParameter } from "../../../models/base-parameter";
import { PersonServices } from "../../../services/person.services";
import PersonStoreTypes from "./types.store";
import { IListing } from "../../../models/listing-base-model";
import { IPersonListState } from "./states.store";
import {ApiResponse} from "../../../models/app-configuration";

const actions = <ActionTree<IPersonListState, any>>{
	[PersonStoreTypes.Get.LIST_OF_PEOPLE]: (
		{ getters, commit },
		params: GenericBaseParameter<PersonSmartSearchParameterModel>
	) => {
		return (getters.service as PersonServices)
			.getListOfPeople(params)
			.then((listingResult: IListing<IPersonListingModel>) => {
				return Promise.resolve(listingResult);
			})
			.catch(error => {
				return Promise.reject(error);
			});
	},
	[PersonStoreTypes.Get.LIST_OF_PEOPLE_WITH_CANCEL_TOKEN]: (
		{ getters, commit },
		payload: { params: GenericBaseParameter<PersonSmartSearchParameterModel>, cancelTokenSource?: any }
	) => {
		return (getters.service as PersonServices)
			.getListOfPeople(payload.params, payload.cancelTokenSource)
			.then((listingResult: IListing<IPersonListingModel>) => {
				return Promise.resolve(listingResult);
			})
			.catch(error => {
				return Promise.reject(error);
			});
	},

	[PersonStoreTypes.Set.DELETE_PEOPLE]: (
		{ getters, commit },
		ids: number[]
	) => {
		return getters.service.deletePeople(ids);
	},
	
	[PersonStoreTypes.Get.LIST_OF_CRITERIA]: ({getters, commit}, param: PersonSmartSuggestionModel) => {
		return getters.service.getCriterias(param)
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					return Promise.resolve(response.data);
				}
				return Promise.resolve([]);
			})
			.catch(ex => {
				return Promise.reject(ex);
			});
	}
};

export default actions;
